/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import {
  CourierCustomer,
  CourierCustomerFromJSON,
  CourierCustomerToJSON,
} from './CourierCustomer';
import {
  CourierUser,
  CourierUserFromJSON,
  CourierUserToJSON,
} from './CourierUser';
import { Invoice, InvoiceFromJSON, InvoiceToJSON } from './Invoice';
import {
  StorageSpot,
  StorageSpotFromJSON,
  StorageSpotToJSON,
} from './StorageSpot';
import {
  StoreLocation,
  StoreLocationFromJSON,
  StoreLocationToJSON,
} from './StoreLocation';
import {
  Courier,
  CourierFromJSON,
  CourierToJSON,
} from './Courier';

/**
 * Serialize a date field defensively. Callers reach these models through
 * `as any` payloads all over the apps, so a plain `value.toISOString()` turns
 * an ISO string into a TypeError that kills the request before it is sent.
 */
function dateToJSON(value: any): string | undefined {
  if (value == null) return undefined;
  return value instanceof Date ? value.toISOString() : String(value);
}

/**
 *
 * @export
 * @interface NewCourierPackage
 */
export interface NewCourierPackage {
  /**
   *
   * @type {string}
   * @memberof NewCourierPackage
   */
  trackingNo: string;
  /**
   * A second carrier tracking number on the same label (e.g. the USPS number
   * on a UPS SurePost label). Packages are matched on either number.
   * @type {string}
   * @memberof NewCourierPackage
   */
  alternateTrackingNo?: string | null;
  /**
   *
   * @type {string}
   * @memberof NewCourierPackage
   */
  description?: string;
  /**
   *
   * @type {number}
   * @memberof NewCourierPackage
   */
  value?: number;
  /**
   *
   * @type {number}
   * @memberof NewCourierPackage
   */
  customsFee?: number;
  /**
   *
   * @type {number}
   * @memberof NewCourierPackage
   */
  deliveryFee?: number;
  /**
   *
   * @type {number}
   * @memberof NewCourierPackage
   */
  lateFee?: number;
  /**
   * Discount amount to apply to this package's invoice
   * @type {number}
   * @memberof NewCourierPackage
   */
  discount?: number;
  /**
   *
   * @type {Date}
   * @memberof NewCourierPackage
   */
  lastLateFeeAppliedDate?: Date;
  /**
   *
   * @type {boolean}
   * @memberof NewCourierPackage
   */
  isDeleted?: boolean;
  /**
   *
   * @type {Date}
   * @memberof NewCourierPackage
   */
  deletedOn?: Date;
  /**
   *
   * @type {number}
   * @memberof NewCourierPackage
   */
  weight?: number;
  /**
   *
   * @type {Array<string>}
   * @memberof NewCourierPackage
   */
  attachedFile?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof NewCourierPackage
   */
  url?: string;
  /**
   *
   * @type {string}
   * @memberof NewCourierPackage
   */
  merchant?: string;
  /**
   *
   * @type {Date}
   * @memberof NewCourierPackage
   */
  createdOn?: Date;
  /**
   *
   * @type {number}
   * @memberof NewCourierPackage
   */
  createdBy?: number;
  /**
   * Scan-attribution marker. A truthy value tells the server this write came
   * from SmartScan / Scan-In, which then overwrites it with its own clock and
   * sets `scannedBy` from the access token. Must be carried on creates too, or
   * the new package is unattributable and never lands in "Scanned Today".
   * @type {Date}
   * @memberof NewCourierPackage
   */
  scannedAt?: Date;
  /**
   * Server-derived from the access token; sent only by back-fills that seed
   * historical attribution.
   * @type {number}
   * @memberof NewCourierPackage
   */
  scannedBy?: number;
  /**
   *
   * @type {Date}
   * @memberof NewCourierPackage
   */
  lastUpdatedOn?: Date;
  /**
   *
   * @type {Date}
   * @memberof NewCourierPackage
   */
  warehouseDate?: Date;
  /**
   *
   * @type {Date}
   * @memberof NewCourierPackage
   */
  readyDate?: Date;
  /**
   *
   * @type {Date}
   * @memberof NewCourierPackage
   */
  deliveredDate?: Date;
  /**
   *
   * @type {Date}
   * @memberof NewCourierPackage
   */
  inTransitDate?: Date;
  /**
   *
   * @type {Date}
   * @memberof NewCourierPackage
   */
  preAlertDate?: Date;
  /**
   *
   * @type {Date}
   * @memberof NewCourierPackage
   */
  arrivedInJamaicaDate?: Date;
  /**
   *
   * @type {Date}
   * @memberof NewCourierPackage
   */
  onRouteToBranchDate?: Date;
  /**
   *
   * @type {string}
   * @memberof NewCourierPackage
   */
  status?: string;
  /**
   *
   * @type {string}
   * @memberof NewCourierPackage
   */
  source?: string;
  /**
   *
   * @type {string}
   * @memberof NewCourierPackage
   */
  manifestNumber?: string;
  /**
   *
   * @type {boolean}
   * @memberof NewCourierPackage
   */
  businessPackage?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof NewCourierPackage
   */
  isHalfPound?: boolean;
  /**
   *
   * @type {number}
   * @memberof NewCourierPackage
   */
  ownerId?: number;
  /**
   *
   * @type {number}
   * @memberof NewCourierPackage
   */
  courierId?: number;
  /**
   *
   * @type {number}
   * @memberof NewCourierPackage
   */
  storeLocationId?: number;
  /**
   *
   * @type {number}
   * @memberof NewCourierPackage
   */
  manifestId?: number;
  /**
   *
   * @type {number}
   * @memberof NewCourierPackage
   */
  recipientId?: number;

  recipient?: CourierCustomer;

  recipientUserId?: number;

  recipientUser?: CourierUser;

  owner?: CourierUser;
  subCourierUser?: CourierCustomer;
  invoice?: Invoice;
  serviceFee?: number;
  isSeaFreight?: boolean;
  length?: number;
  width?: number;
  height?: number;
  isBarrel?: boolean;
  isExpress?: boolean;
  isInvoiceUploaded?: boolean;
  isMislabeled?: boolean;
  isUnknown?: boolean;
  nameOnPackage?: string;
  packageNotes?: string;
  /**
   * Harmonized System code for customs classification
   * @type {string}
   * @memberof NewCourierPackage
   */
  hsCode?: string;
  /**
   * Additional information for customs declarations
   * @type {object}
   * @memberof NewCourierPackage
   */
  customsInfo?: {
    freightValue?: number;
    freightCurrency?: string;
    insuranceValue?: number;
    insuranceCurrency?: string;
    transportValue?: number;
    transportCurrency?: string;
    pcIndicator?: string;
  };
  /**
   * Information for container shipments
   * @type {object}
   * @memberof NewCourierPackage
   */
  containerInfo?: {
    containerNumber?: string;
    sealNumber?: string;
    containerType?: string;
    emptyFull?: string;
    emptyWeight?: number;
  };
  /**
   *
   * @type {number}
   * @memberof NewCourierPackage
   */
  storageSpotId?: number;
  /**
   *
   * @type {StorageSpot}
   * @memberof NewCourierPackage
   */
  storageSpot?: StorageSpot;
  /**
   *
   * @type {StoreLocation}
   * @memberof NewCourierPackage
   */
  storeLocation?: StoreLocation;
  /**
   *
   * @type {Courier}
   * @memberof NewCourierPackage
   */
  courier?: Courier;
}

/**
 * Check if a given object implements the NewCourierPackage interface.
 */
export function instanceOfNewCourierPackage(
  value: object
): value is NewCourierPackage {
  if (!('trackingNo' in value) || value['trackingNo'] === undefined)
    return false;
  return true;
}

export function NewCourierPackageFromJSON(json: any): NewCourierPackage {
  return NewCourierPackageFromJSONTyped(json, false);
}

export function NewCourierPackageFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): NewCourierPackage {
  if (json == null) {
    return json;
  }
  return {
    trackingNo: json['trackingNo'],
    alternateTrackingNo: json['alternateTrackingNo'] == null ? undefined : json['alternateTrackingNo'],
    description: json['description'] == null ? undefined : json['description'],
    value: json['value'] == null ? undefined : json['value'],
    customsFee: json['customsFee'] == null ? undefined : json['customsFee'],
    deliveryFee: json['deliveryFee'] == null ? undefined : json['deliveryFee'],
    lateFee: json['lateFee'] == null ? undefined : json['lateFee'],
    discount: json['discount'] == null ? undefined : json['discount'],
    lastLateFeeAppliedDate:
      json['lastLateFeeAppliedDate'] == null
        ? undefined
        : new Date(json['lastLateFeeAppliedDate']),
    isDeleted: json['isDeleted'] == null ? undefined : json['isDeleted'],
    deletedOn:
      json['deletedOn'] == null ? undefined : new Date(json['deletedOn']),
    weight: json['weight'] == null ? undefined : json['weight'],
    attachedFile:
      json['attachedFile'] == null ? undefined : json['attachedFile'],
    url: json['url'] == null ? undefined : json['url'],
    merchant: json['merchant'] == null ? undefined : json['merchant'],
    createdOn:
      json['createdOn'] == null ? undefined : new Date(json['createdOn']),
    createdBy: json['createdBy'] == null ? undefined : json['createdBy'],
    scannedAt:
      json['scannedAt'] == null ? undefined : new Date(json['scannedAt']),
    scannedBy: json['scannedBy'] == null ? undefined : json['scannedBy'],
    lastUpdatedOn:
      json['lastUpdatedOn'] == null
        ? undefined
        : new Date(json['lastUpdatedOn']),
    warehouseDate:
      json['warehouseDate'] == null
        ? undefined
        : new Date(json['warehouseDate']),
    readyDate:
      json['readyDate'] == null ? undefined : new Date(json['readyDate']),
    deliveredDate:
      json['deliveredDate'] == null
        ? undefined
        : new Date(json['deliveredDate']),
    inTransitDate:
      json['inTransitDate'] == null
        ? undefined
        : new Date(json['inTransitDate']),
    preAlertDate:
      json['preAlertDate'] == null ? undefined : new Date(json['preAlertDate']),
    arrivedInJamaicaDate:
      json['arrivedInJamaicaDate'] == null
        ? undefined
        : new Date(json['arrivedInJamaicaDate']),
    onRouteToBranchDate:
      json['onRouteToBranchDate'] == null
        ? undefined
        : new Date(json['onRouteToBranchDate']),
    status: json['status'] == null ? undefined : json['status'],
    source: json['source'] == null ? undefined : json['source'],
    manifestNumber:
      json['manifestNumber'] == null ? undefined : json['manifestNumber'],
    businessPackage:
      json['businessPackage'] == null ? undefined : json['businessPackage'],
    isHalfPound: json['isHalfPound'] == null ? undefined : json['isHalfPound'],
    ownerId: json['ownerId'] == null ? undefined : json['ownerId'],
    courierId: json['courierId'] == null ? undefined : json['courierId'],
    storeLocationId:
      json['storeLocationId'] == null ? undefined : json['storeLocationId'],
    manifestId: json['manifestId'] == null ? undefined : json['manifestId'],
    recipientId: json['recipientId'] == null ? undefined : json['recipientId'],
    recipientUserId:
      json['recipientUserId'] == null ? undefined : json['recipientUserId'],
    recipientUser:
      json['recipientUser'] == null
        ? undefined
        : CourierUserFromJSON(json['recipientUser']),
    owner:
      json['owner'] == null ? undefined : CourierUserFromJSON(json['owner']),
    subCourierUser:
      json['subCourierUser'] == null
        ? undefined
        : CourierCustomerFromJSON(json['subCourierUser']),
    invoice:
      json['invoice'] == null ? undefined : InvoiceFromJSON(json['invoice']),
    serviceFee: json['serviceFee'] == null ? undefined : json['serviceFee'],
    isSeaFreight:
      json['isSeaFreight'] == null ? undefined : json['isSeaFreight'],
    length: json['length'] == null ? undefined : json['length'],
    width: json['width'] == null ? undefined : json['width'],
    height: json['height'] == null ? undefined : json['height'],
    isBarrel: json['isBarrel'] == null ? undefined : json['isBarrel'],
    isExpress: json['isExpress'] == null ? undefined : json['isExpress'],
    isInvoiceUploaded:
      json['isInvoiceUploaded'] == null ? undefined : json['isInvoiceUploaded'],
    isMislabeled: json['isMislabeled'] == null ? undefined : json['isMislabeled'],
    isUnknown: json['isUnknown'] == null ? undefined : json['isUnknown'],
    nameOnPackage: json['nameOnPackage'] == null ? undefined : json['nameOnPackage'],
    packageNotes: json['packageNotes'] == null ? undefined : json['packageNotes'],
    hsCode: json['hsCode'] == null ? undefined : json['hsCode'],
    customsInfo: json['customsInfo'] == null ? undefined : json['customsInfo'],
    containerInfo: json['containerInfo'] == null ? undefined : json['containerInfo'],
    storageSpotId:
      json['storageSpotId'] == null ? undefined : json['storageSpotId'],
    storageSpot:
      json['storageSpot'] == null
        ? undefined
        : StorageSpotFromJSON(json['storageSpot']),
    storeLocation:
      json['storeLocation'] == null
        ? undefined
        : StoreLocationFromJSON(json['storeLocation']),
    courier:
      json['courier'] == null ? undefined : CourierFromJSON(json['courier']),
  };
}

export function NewCourierPackageToJSON(json: any): NewCourierPackage {
  return NewCourierPackageToJSONTyped(json, false);
}

export function NewCourierPackageToJSONTyped(
  value?: NewCourierPackage | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    trackingNo: value['trackingNo'],
    alternateTrackingNo: value['alternateTrackingNo'],
    description: value['description'],
    value: value['value'],
    customsFee: value['customsFee'],
    deliveryFee: value['deliveryFee'],
    lateFee: value['lateFee'],
    discount: value['discount'],
    weight: value['weight'],
    attachedFile: value['attachedFile'],
    url: value['url'],
    merchant: value['merchant'],
    createdOn:
      value['createdOn'] == null ? undefined : value['createdOn'].toISOString(),
    createdBy: value['createdBy'],
    scannedAt: dateToJSON(value['scannedAt']),
    scannedBy: value['scannedBy'],
    lastUpdatedOn:
      value['lastUpdatedOn'] == null
        ? undefined
        : value['lastUpdatedOn'].toISOString(),
    warehouseDate:
      value['warehouseDate'] == null
        ? undefined
        : value['warehouseDate'].toISOString(),
    readyDate:
      value['readyDate'] == null ? undefined : value['readyDate'].toISOString(),
    deliveredDate:
      value['deliveredDate'] == null
        ? undefined
        : value['deliveredDate'].toISOString(),
    inTransitDate:
      value['inTransitDate'] == null
        ? undefined
        : value['inTransitDate'].toISOString(),
    preAlertDate:
      value['preAlertDate'] == null
        ? undefined
        : value['preAlertDate'].toISOString(),
    arrivedInJamaicaDate:
      value['arrivedInJamaicaDate'] == null
        ? undefined
        : value['arrivedInJamaicaDate'].toISOString(),
    onRouteToBranchDate:
      value['onRouteToBranchDate'] == null
        ? undefined
        : value['onRouteToBranchDate'].toISOString(),
    status: value['status'],
    source: value['source'],
    manifestNumber: value['manifestNumber'],
    businessPackage: value['businessPackage'],
    isHalfPound: value['isHalfPound'],
    ownerId: value['ownerId'],
    courierId: value['courierId'],
    storeLocationId: value['storeLocationId'],
    manifestId: value['manifestId'],
    recipientId: value['recipientId'],
    recipientUserId: value['recipientUserId'],
    recipientUser:
      value['recipientUser'] == null
        ? undefined
        : CourierUserToJSON(value['recipientUser']),
    owner:
      value['owner'] == null ? undefined : CourierUserToJSON(value['owner']),
    subCourierUser: value['subCourierUser'],
    invoice:
      value['invoice'] == null ? undefined : InvoiceToJSON(value['invoice']),
    serviceFee: value['serviceFee'],
    isSeaFreight: value['isSeaFreight'],
    length: value['length'],
    width: value['width'],
    height: value['height'],
    isBarrel: value['isBarrel'],
    isExpress: value['isExpress'],
    isInvoiceUploaded: value['isInvoiceUploaded'],
    isMislabeled: value['isMislabeled'],
    isUnknown: value['isUnknown'],
    nameOnPackage: value['nameOnPackage'],
    packageNotes: value['packageNotes'],
    lastLateFeeAppliedDate:
      value['lastLateFeeAppliedDate'] == null
        ? undefined
        : value['lastLateFeeAppliedDate'].toISOString(),
    isDeleted: value['isDeleted'],
    deletedOn:
      value['deletedOn'] == null ? undefined : value['deletedOn'].toISOString(),
    hsCode: value['hsCode'],
    customsInfo: value['customsInfo'],
    containerInfo: value['containerInfo'],
    storageSpotId: value['storageSpotId'],
    storageSpot:
      value['storageSpot'] == null
        ? undefined
        : StorageSpotToJSON(value['storageSpot']),
    storeLocation:
      value['storeLocation'] == null
        ? undefined
        : StoreLocationToJSON(value['storeLocation']),
    courier:
      value['courier'] == null ? undefined : CourierToJSON(value['courier']),
  };
}
